/**
 * Apple's `passwordrules` attribute for this app's password policy, written into
 * `window.PnBaseData` by Blade. Safari and password managers (1Password,
 * Keychain) read it when generating a password, so what they suggest passes
 * server-side validation first time; anything that doesn't understand the
 * attribute ignores it.
 *
 * Belongs on fields where a password is *set* — pair it with
 * `autocomplete="new-password"`. Derived from `App\User::passwordRulesString()`,
 * so the policy is stated once and the hint can't drift from the rules.
 */
export function usePasswordRules() {
    // Optional chaining throughout: the sign-up page and the SPAs all provide
    // this, but a field rendered without the global should go without the hint
    // rather than crash.
    return {
        passwordRules: window.PnBaseData?.security?.passwordRules,
    }
}
